import { useState } from 'react';
import { db, storage } from '../../lib/firebase'; // adjust path as needed
import { doc, updateDoc } from 'firebase/firestore';
import { ref, deleteObject, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

const useEditProduct = () => {
  const [updating, setUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const updateProduct = async (productId, data) => {
    setUpdating(true);
    setUpdateError(null);
    try {
      const productRef = doc(db, 'products', productId);
      await updateDoc(productRef, data);
    } catch (err) {
      setUpdateError(err);
    } finally {
      setUpdating(false);
    }
  };

  const deleteProductImage = async (productId, imageUrl) => {
    if (!imageUrl) return false;
    try {
      const path = decodeURIComponent(
        new URL(imageUrl).pathname.split('/o/')[1].split('?')[0]
      );
      const imageRef = ref(storage, path);
      await deleteObject(imageRef);

      await updateProduct(productId, { imageUrl: '' });
      return true;
    } catch (err) {
      console.error('Failed to delete image:', err);
      return false;
    }
  };

  const uploadProductImage = async (productId, file) => {
    try {
      const filePath = `products/${productId}/${uuidv4()}-${file.name}`;
      const imageRef = ref(storage, filePath);
      await uploadBytes(imageRef, file);
      const downloadURL = await getDownloadURL(imageRef);

      await updateProduct(productId, { imageUrl: downloadURL });
      return downloadURL;
    } catch (err) {
      console.error('Image upload failed:', err);
      throw err;
    }
  };

  return {
    updateProduct,
    deleteProductImage,
    uploadProductImage,
    updating,
    updateError,
  };
};

export default useEditProduct;
